<template>
    <!-- Steps 步骤条-组件 -->
    <div class="formStep">
      <div v-for="(item,index) in stepData" v-bind:key="index">
        <div
          :class="((stepActive > index ?'stepItemSuccess stepItem':(stepActive == index ? 'stepItemActive stepItem':'stepItem')))"
          :style="index==0 ?'margin-top: 0px;' : ''"
        >
          <div class="stepIndex">
            <img src="../assets/svg/yes.svg" style="width: 100%;" v-if="stepActive > index" />
          </div>
          <div class="stepStatus stepName">{{item.status}}</div>
        </div>
      </div>
      <div class="stepLine" :style="{height:(stepData.length)*55+'px'}"></div>
      <div
        class="stepActiveLine"
        :style="{height:stepActive > stepData.length ? (stepData.length)*70+'px':(stepActive)*70+'px'}"
      ></div>
    </div>
</template>
<script>
export default {
  name: "formStep",
  props: {
    stepData: {
      type: Array
    },
    stepActive: {
      default: 1
    }
  },
};
</script>
<style scoped lang="scss">
.formStep {
    overflow: hidden;
  position: relative;
  width: 160px;
  margin: auto;
  height: 260px;

  .stepLine, .stepActiveLine {
    width: 4px;
    position: absolute;
    // left: 28px;
    // top: 70px; // 修改了 top 的值
    // margin-top: 80px;
    
    left: 13px;
    top: 35px;
    // margin-top: 40px;
  }

  .stepLine {
    background: #d7d7d7;
  }
  
  .stepActiveLine {
    background: green;
    z-index: 5;
  }
  
  .stepItem {
    position: relative;
    z-index: 10;
    margin-top: 35px; // 修改了 margin-top 的值

    .stepName {
      font-size: 16px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #8b8b8b;
      margin-left: 50px;
    }

    .stepIndex {
      width: 30px;
      height: 30px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;
      background: #8b8b8b;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.formStep .stepItemSuccess.stepItem .stepName {
  color: #181818;
}

.formStep .stepItemSuccess.stepItem .stepIndex {
  background: green;
}

.formStep .stepItemError.stepItem .stepName {
  color: #f00000;
}

.formStep .stepItemError.stepItem .stepIndex {
  background: #f00000;
}
</style>
